import React from "react";
import "../styles/TrackLinkModal.css";

interface TrackLinkModel {
  id: string;
  artistName: string;
  trackTitle: string;
  platformLinks?: Record<string, string>;
}

interface TrackModalProps {
  isOpen: boolean;
  onClose: () => void;
  track: TrackLinkModel;
  onTrackPlay?: (trackId: string, platform: string) => void;
}

const SUPPORTED_PLATFORMS = [
  { key: "spotify", label: "Spotify", color: "#1DB954" },
  { key: "appleMusic", label: "Apple Music", color: "#e64d58" },
  { key: "youtubeMusic", label: "YouTube Music", color: "#FF0000" },
  { key: "tidal", label: "Tidal", color: "#00FFFF" },
  { key: "soundcloud", label: "Soundcloud", color: "#FF5500" },
  { key: "amazonMusic", label: "Amazon Music", color: "#FF9900" },
];

export const TrackModal = ({ 
  isOpen, 
  onClose, 
  track, 
  onTrackPlay 
}: TrackModalProps) => {
  if (!isOpen) return null;

  const handlePlatformClick = (url: string, platformKey: string) => {
    if (onTrackPlay) {
      onTrackPlay(track.id, platformKey);
    }

    window.location.href = url;

    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <h3 className="modal-header">Tap Where To Listen</h3>

        <div className="links-container">
          {SUPPORTED_PLATFORMS.map(({ key, label, color }) => {
            const url = track.platformLinks?.[key];

            if (!url) return null;

            return (
              <button
                key={key}
                className="listen-btn"
                onClick={() => handlePlatformClick(url, key)}
              >
                <div className="btn-content">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="icon-headphones"
                  >
                    <path d="M3 18v-6a9 9 0 0 1 18 0v6"></path>
                    <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"></path>
                  </svg>

                  <span className="listen-text">
                    Listen on <span style={{ color: color }}>{label}</span>
                  </span>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};
